import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Avatar, Divider, Drawer, Stack, Typography } from "@mui/material";
import {
    AccountCircle,
    DarkModeRounded,
    LightModeRounded,
    MenuRounded,
} from "@mui/icons-material";
import { IconButton } from "../Buttons";
import Sidebar from "../Sidebar";
import { useAppTheme } from "../../theme/AppTheme";
import { toCapitalize } from "../../utils/text-format";

export default function Navbar() {
    const { pathname } = useLocation();
    const { theme, toggleTheme } = useAppTheme();
    const [open, setOpen] = useState(false);
    const firstName = localStorage.getItem("firstName") ?? "User";

    /* Close the mobile drawer whenever the route changes. */
    useEffect(() => {
        setOpen(false);
    }, [pathname]);

    return (
        <Stack
            sx={{
                flexDirection: "row",
                alignItems: "center",
                height: "60px",
                background: "var(--header-bg)",
                color: "var(--header-text)",
                paddingInline: "12px",
                gap: "12px",
            }}
        >
            <Stack
                sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "212px",
                    display: { xs: "none", sm: "flex" },
                }}
            >
                <Stack
                    sx={{
                        flexDirection: "row",
                        alignItems: "baseline",
                        gap: "8px",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Newsreader', Georgia, serif",
                            fontSize: "22px",
                            fontWeight: 500,
                            letterSpacing: "-0.5px",
                            lineHeight: 1,
                        }}
                    >
                        tessera
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "9px",
                            letterSpacing: "2.5px",
                            fontWeight: 600,
                            color: "var(--text-tertiary)",
                            lineHeight: 1,
                        }}
                    >
                        CRM
                    </Typography>
                </Stack>

                <Divider
                    orientation="vertical"
                    sx={{
                        borderColor: "var(--border-mid)",
                        height: "24px",
                        alignSelf: "center",
                    }}
                />
            </Stack>

            <Stack
                sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                }}
            >
                <Stack
                    sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                    }}
                >
                    <IconButton
                        variant="text"
                        textColor="var(--header-text)"
                        onClick={() => setOpen(true)}
                        sx={{ display: { xs: "flex", sm: "none" } }}
                    >
                        <MenuRounded />
                    </IconButton>

                    <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
                        {(() => {
                            const h = new Date().getHours();
                            if (h < 12) return "Good Morning, ";
                            if (h < 17) return "Good Afternoon, ";
                            return "Good Evening, ";
                        })()}
                        {toCapitalize(firstName)}
                    </Typography>
                </Stack>

                <Stack
                    sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                    }}
                >
                    <IconButton
                        variant="text"
                        textColor="var(--header-text)"
                        onClick={toggleTheme}
                    >
                        {theme === "dark" ? (
                            <LightModeRounded />
                        ) : (
                            <DarkModeRounded />
                        )}
                    </IconButton>

                    <Avatar
                        sx={{
                            backgroundColor: "var(--accent)",
                            color: "#ffffff",
                            width: 36,
                            height: 36,
                            fontSize: 14,
                            fontWeight: 700,
                        }}
                    >
                        {firstName?.[0]?.toUpperCase() ?? <AccountCircle />}
                    </Avatar>
                </Stack>
            </Stack>

            <Drawer open={open} onClose={() => setOpen(false)}>
                <Stack
                    sx={{
                        backgroundColor: "var(--bg)",
                        height: "100%",
                        padding: "12px",
                    }}
                >
                    <Sidebar />
                </Stack>
            </Drawer>
        </Stack>
    );
}
